export const API_ENDPOINTS = {
  // Reports
  REPORTS_YEAR_WISE: '/certificate-requests/year-wise-report',
  

  // Certificates
  CERTIFICATES: '/certificates',
  CERTIFICATE_BY_ID: (id: string | number) => `/certificate-requests/${id}`,
  CERTIFICATE_BOOKLETS: '/certificate-booklets',
  CERTIFICATES_PRESIGNED_URL: '/certificates/presigned-url',
  CERTIFICATES_ISSUED_BY_LEVEL: (level: string) => `/certificates/issued/by-level/${level}`,
  CERTIFICATE_BOOKLETS_BY_USER:(userId:string)=> `users/${userId}/certificate-booklets/`,

  // Certificate Requests
  CERTIFICATE_REQUESTS: '/certificate-requests',
  CERTIFICATE_REQUESTS_DELIVER:(requestId:string)=> `/certificate-requests/${requestId}/deliver`,
  CERTIFICATE_REQUESTS_CANCEL:(requestId:string)=> `/certificate-requests/${requestId}/cancel`,
  CERTIFICATE_REQUESTS_REJECT:(requestId:string)=> `/certificate-requests/${requestId}/reject`,
  CERTIFICATE_REQUESTS_APPROVE:(requestId:string)=> `/certificate-requests/${requestId}/approve`,
  CERTIFICATE_REQUEST_BY_ID: (id: string | number) => `/certificate-requests/${id}`,
  CERTIFICATE_REQUESTS_COUNT: '/certificate-requests/count',
  CERTIFICATES_BY_LOCATION: '/certificates/by-location',

  // Partners
  PARTNERS_MAPPED_DISTRIBUTORS: (userId: string) => `/users/${userId}/reporting-users`,
  PARTNERS_SUMMARY: '/partners/partnersummary',
  PARTNER_SEARCH: (userId: string) => `/partners/search?partner_id=${userId}`,

  // Users
  USERS: '/users',
  USER_BY_ID: (id: string) => `/users/${id}`,
  USER_SUBORDINATES: (userId: string) => `/users/${userId}/reporting-users`,
  USER_CERTIFICATES: (userId: string) => `/users/${userId}/certificates`,

  // Dashboard
  DASHBOARD_SUMMARY: '/dashboard/summary',

  // Pending Requests (from Redux thunk)
  PENDING_REQUESTS: '/certificate-requests/pending',
  ISSUED_CERTIFICATES: '/certificates/issued',

  // Locations
  LOCATIONS_UNITS: '/locations/units',
  LOCATIONS_SQUADS: '/locations/squads',
  LOCATIONS_TERRITORIES: '/locations/territories',


  // Fetching Available Certificate Numbers
  FETCH_AVAILABLE_NUMBERS :(userId:string)=> `/users/${userId}/available-certificate-numbers`,

  // Managers
  USER_MANAGERS: (userId: string) => `/users/${userId}/squad-lead`,



  // new revamped code
  CERTIFICATE_REQUESTS_BY_USER : (userId: string) => `/users/${userId}/certificate-requests`,
  APPROVED_REQUESTS_BY_ISSUER: (userId: string) => `/issuers/${userId}/approved-requests`,
  CERTIFICATE_REQUESTS_BY_BOOKLET_ID : (bookletId: any) => `/certificate-booklets/${bookletId}/certificates`,


  MAPPED_DISTRIBUTORS: (userId: string) => `/users/${userId}/distributors`,



  USER_VIEWED_GUIDED_TOUR_STEP:(userId:string, step:number)=> `/users/${userId}/guided-tours/${step}/viewed`,
};
